import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import type { IconFileTypeProps } from '../types.ts';
import { FileTypeBaseComponent } from './BaseComponent.tsx';

const FileFormat = React.forwardRef<SVGSVGElement | null, IconFileTypeProps>(function FileFormat({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef(() => (
    <>
      <path
        d='M20.9506 7.38855C20.1305 7.38775 19.3442 7.06161 18.7643 6.48173C18.1845 5.90184 17.8583 5.11558 17.8575 4.2955V0.000976562H4.03653C2.96598 0.000976562 1.93927 0.426266 1.18228 1.18326C0.425285 1.94026 0 2.96695 0 4.0375V28.3707C0 29.4413 0.425285 30.468 1.18228 31.225C1.93927 31.982 2.96598 32.4073 4.03653 32.4073H20.6265C21.6971 32.4073 22.7238 31.982 23.4808 31.225C24.2378 30.468 24.6631 29.4413 24.6631 28.3707V7.38855H20.9506Z'
        fill='#EAEBEB'
      />
      <path
        d='M24.6629 7.38757H20.9504C20.1304 7.38678 19.3441 7.06064 18.7642 6.48075C18.1844 5.90087 17.8582 5.1146 17.8574 4.29452V0L24.6629 7.38757Z'
        fill='#6D7176'
      />
      <path
        d='M27.5908 25.5918H8.83479C7.50434 25.5918 6.42578 26.6704 6.42578 28.0008V33.5929C6.42578 34.9233 7.50434 36.0019 8.83479 36.0019H27.5908C28.9213 36.0019 29.9998 34.9233 29.9998 33.5929V28.0008C29.9998 26.6704 28.9213 25.5918 27.5908 25.5918Z'
        fill='#6D7176'
      />
      <path d='M13.1295 31.9937V33.0842H12V31.9937H13.1295Z' fill='white' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.25 9C8.11193 9 8 9.11193 8 9.25V20.75C8 20.8881 8.11193 21 8.25 21H16.75C16.8881 21 17 20.8881 17 20.75V14.75C17 13.7835 16.2165 13 15.25 13H14.25C13.5596 13 13 12.4404 13 11.75V10.75C13 9.7835 12.2165 9 11.25 9H8.25ZM8.25 8C7.55964 8 7 8.55964 7 9.25V20.75C7 21.4404 7.55964 22 8.25 22H16.75C17.4404 22 18 21.4404 18 20.75V14.5C18 10.9101 15.0899 8 11.5 8H8.25ZM13.6714 9.44523C13.881 9.83346 14 10.2778 14 10.75V11.75C14 11.8881 14.1119 12 14.25 12H15.25C15.7222 12 16.1665 12.119 16.5548 12.3286C15.9992 11.037 14.963 10.0008 13.6714 9.44523ZM9.5 17C9.5 16.7239 9.72386 16.5 10 16.5H15C15.2761 16.5 15.5 16.7239 15.5 17C15.5 17.2761 15.2761 17.5 15 17.5H10C9.72386 17.5 9.5 17.2761 9.5 17ZM9.5 19C9.5 18.7239 9.72386 18.5 10 18.5H12.5C12.7761 18.5 13 18.7239 13 19C13 19.2761 12.7761 19.5 12.5 19.5H10C9.72386 19.5 9.5 19.2761 9.5 19Z'
        fill='#6D7176'
      />
      <path
        d='M23.2227 32.9937V28.7397H25.9167V29.6337H24.1707V30.4437H25.7547V31.2777H24.1707V32.0937H25.9227V32.9937H23.2227Z'
        fill='white'
      />
      <path d='M19.8652 32.9937V28.7397H20.8132V32.0877H22.6492V32.9937H19.8652Z' fill='white' />
      <path d='M17.9434 32.9937V28.7397H18.9034V32.9937H17.9434Z' fill='white' />
      <path d='M14.5039 32.9937V28.7397H17.2459V29.6397H15.4519V30.5397H17.0299V31.4037H15.4579V32.9937H14.5039Z' fill='white' />
    </>
  ));

  return <FileTypeBaseComponent ref={ref} dataTestId={dataTestId ?? 'file-format-icon-svg'} iconRender={iconRender} {...props} />;
});

export default FileFormat;
